import { lazy } from 'react';
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';

const ProblemaAgricolaView = Loadable(lazy(() => import('views/forms/form-element/ProblemaAgricolaView')));
const MisRegistrosView = Loadable(lazy(() => import('views/forms/form-element/MisRegistrosView')));
const MiPerfilView = Loadable(lazy(() => import('views/forms/form-element/MiPerfilView')));

const AgricolaRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'agricola',
          children: [
            { path: 'problema', element: <ProblemaAgricolaView /> },
            { path: 'problema/:id', element: <ProblemaAgricolaView /> }, // Ruta para editar pasando el ID del registro
            { path: 'mis-registros', element: <MisRegistrosView /> },
            { path: 'mi-perfil', element: <MiPerfilView /> }
          ]
        }
      ]
    }
  ]
};

export default AgricolaRoutes;